import { render, staticRenderFns } from "./Nuvemshop.vue?vue&type=template&id=fb1f4900&scoped=true&"
import script from "./Nuvemshop.vue?vue&type=script&lang=js&"
export * from "./Nuvemshop.vue?vue&type=script&lang=js&"
import style0 from "./Nuvemshop.vue?vue&type=style&index=0&id=fb1f4900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1f4900",
  null
  
)

export default component.exports